import { Fragment } from 'react';
import { useIntl } from 'react-intl';
import Typography from '@alltrails/core/components/Typography';
import { getDifficultyLevels } from '@alltrails/difficulty/utils/getDifficultyLevels';
import styles from './DifficultyInfoModalContent.module.scss';

const DifficultyInfoModalContent = () => {
  const intl = useIntl();
  const difficultyLevels = getDifficultyLevels(intl, { iconSize: 'xs' });

  return (
    <>
      <div className={styles.difficultyLevels}>
        {difficultyLevels.map(({ title, description }, index) => (
          <Fragment key={index}>
            <Typography variant="heading200" className={styles.difficultyLevelTitle}>
              {title}
            </Typography>
            <Typography variant="text100" color="secondary" className={styles.difficultyLevelDescription}>
              {description}
            </Typography>
          </Fragment>
        ))}
      </div>
    </>
  );
};

export default DifficultyInfoModalContent;
